"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavbarCenterSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _desktopMenuItem = _interopRequireDefault(require("../navigation-items/desktop-menu-item.js"));
var _desktopNavLink = _interopRequireDefault(require("../navigation-items/desktop-nav-link.js"));
var _base = require("@site/pattern-library-utils/base.functions");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// ============================================================================
// CONSTANTS
// ============================================================================

/**
 * Maximum number of dropdown items that can have nested submenus.
 * This limit ensures reasonable performance and prevents excessive CSS generation
 * while covering realistic navigation menu sizes.
 */
const MAX_NESTED_DROPDOWN_ITEMS = 10;

// ============================================================================
// STYLED COMPONENTS
// ============================================================================

const DesktopMenuContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DesktopMenuContainer",
  class: "pl-d1e7iyrq"
});
const DesktopMenu = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "DesktopMenu",
  class: "pl-d1tq2y3e"
});
const DropdownMainContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DropdownMainContainer",
  class: "pl-d7hwtj5"
});
const DropdownItemsContainer = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "DropdownItemsContainer",
  class: "pl-dn0jimq"
});
const DropdownNestedContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DropdownNestedContainer",
  class: "pl-d1ih7aiy"
});
const DropdownNestedItems = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "DropdownNestedItems",
  class: "pl-d1onxs0s"
});
const DropdownListContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DropdownListContainer",
  class: "pl-d3ejjnx"
});
const DropdownLink = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "DropdownLink",
  class: "pl-drdvuvm"
});
const MoreButtonDesktopMenuItem = /*#__PURE__*/(0, _react2.styled)(_desktopMenuItem.default)({
  name: "MoreButtonDesktopMenuItem",
  class: "pl-m1b8n853"
});
const DropdownNestedLink = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "DropdownNestedLink",
  class: "pl-d2pdk31"
});
const MoreNestedItemLink = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MoreNestedItemLink",
  class: "pl-mwvri0j"
});
const MoreNestedChevron = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "MoreNestedChevron",
  class: "pl-mvr1ysw"
});
const MoreSubDropdown = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MoreSubDropdown",
  class: "pl-m1ilemea",
  vars: {
    "m1ilemea-0": [({
      isVisible
    }) => isVisible ? 'flex' : 'none']
  }
});
const MoreSubDropdownItems = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "MoreSubDropdownItems",
  class: "pl-m1b2ckf1"
});

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================

const CHILDREN_ITEM_NAME = 'children';
const hasChildrenStructure = items => {
  return items?.length === 1 && items[0]._name === CHILDREN_ITEM_NAME;
};
const extractItemList = items => {
  return hasChildrenStructure(items) ? items[0].items : items;
};
const hasDropdownContent = (items, itemList) => {
  return items?.length > 0 && itemList;
};
const hasNestedItems = items => {
  // Support both old wrapper structure and new direct array structure
  return items && (items[0]?.items || Array.isArray(items) && items.length > 0 && typeof items[0] === 'object');
};

// ============================================================================
// MAIN COMPONENT
// ============================================================================

/**
 * Navbar Center Section Component
 *
 * Renders the main navigation menu in the center of the navbar with dropdown functionality.
 * Supports nested menu items, responsive behavior, and More dropdown for overflow.
 * @param {Object} props - Component props
 * @returns {React.ReactElement} Navbar Center Section Component
 */
function NavbarCenterSection({
  liveList: navigationItems,
  scrollToAnchor,
  partial,
  listMenuRef,
  hasOverflow = false,
  visibleItemsCount = 0,
  moreItems = []
}) {
  const [hoveredMoreItemIndex, setHoveredMoreItemIndex] = (0, _react.useState)(null);
  const [clickedMoreItemIndex, setClickedMoreItemIndex] = (0, _react.useState)(null);
  const hoverTimeoutRef = (0, _react.useRef)(null);
  const moreDropdownRef = (0, _react.useRef)(null);
  const showSubmenu = itemIndex => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    setHoveredMoreItemIndex(itemIndex);
  };
  const hideSubmenu = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      // Only hide on hover if not clicked/pinned
      if (clickedMoreItemIndex === null) {
        setHoveredMoreItemIndex(null);
      }
      hoverTimeoutRef.current = null;
    }, 150); // 150ms delay to allow mouse movement to submenu
  };
  const cancelHideSubmenu = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
  };
  const handleParentItemClick = itemIndex => {
    if (clickedMoreItemIndex === itemIndex) {
      // Clicking same item closes it
      setClickedMoreItemIndex(null);
      setHoveredMoreItemIndex(null);
    } else {
      // Clicking different item opens it and keeps it pinned
      setClickedMoreItemIndex(itemIndex);
      setHoveredMoreItemIndex(itemIndex);
    }
  };
  const isSubmenuVisible = itemIndex => {
    return hoveredMoreItemIndex === itemIndex || clickedMoreItemIndex === itemIndex;
  };
  const isMoreButtonActive = () => {
    return hoveredMoreItemIndex !== null || clickedMoreItemIndex !== null;
  };
  (0, _base.useClickOutside)(moreDropdownRef.current, () => {
    setClickedMoreItemIndex(null);
    setHoveredMoreItemIndex(null);
  }, 'mousedown');
  (0, _react.useEffect)(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, []);
  if (!navigationItems || !Array.isArray(navigationItems)) {
    return /*#__PURE__*/_react.default.createElement(DesktopMenuContainer, {
      className: "navbar-center-section",
      "data-cy": "desktop-menu-container"
    }, /*#__PURE__*/_react.default.createElement(DesktopMenu, {
      className: "navbar-center-section__menu",
      "data-cy": "list-menu",
      ref: listMenuRef
    }));
  }

  // Determine which items to render based on overflow state
  const itemsToRender = hasOverflow ? navigationItems.slice(0, visibleItemsCount) // Only visible items when overflowing
  : navigationItems; // All items when not overflowing (normal behavior)

  return /*#__PURE__*/_react.default.createElement(DesktopMenuContainer, {
    className: "navbar-center-section",
    "data-cy": "desktop-menu-container"
  }, /*#__PURE__*/_react.default.createElement(DesktopMenu, {
    className: "navbar-center-section__menu",
    "data-cy": "list-menu",
    ref: listMenuRef
  }, itemsToRender.filter(Boolean).map((menuItem, itemIndex) => {
    const {
      items
    } = menuItem || {};
    const processedItemList = extractItemList(items);
    if (hasDropdownContent(items, processedItemList)) {
      const {
        _name: itemName,
        title
      } = menuItem;
      return /*#__PURE__*/_react.default.createElement(_desktopMenuItem.default, {
        key: itemIndex,
        _name: itemName,
        order: itemIndex,
        itemText: title,
        "data-cy": "nav-item",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement(DropdownListContainer, null, /*#__PURE__*/_react.default.createElement(DropdownMainContainer, null, /*#__PURE__*/_react.default.createElement(DropdownItemsContainer, {
        "data-cy": "dropdown-list",
        "data-partial": partial
      }, processedItemList?.map((dropdownItem, dropdownIndex) => {
        const shouldNest = hasNestedItems(dropdownItem.items);
        return /*#__PURE__*/_react.default.createElement(DropdownLink, (0, _extends2.default)({
          key: dropdownIndex
        }, shouldNest ? {
          ['data-dropdown-item-index']: dropdownIndex
        } : {}), /*#__PURE__*/_react.default.createElement(_desktopNavLink.default, (0, _extends2.default)({
          tabIndex: 0
        }, shouldNest ? {} : {
          scrollToAnchor
        }, dropdownItem)));
      })), processedItemList?.map((nestedParent, nestedParentIndex) => {
        if (hasNestedItems(nestedParent.items)) {
          const {
            items: nestedItemsList
          } = nestedParent;
          const nestedItems = nestedItemsList[0]?.items ? nestedItemsList[0].items : nestedItemsList;
          return /*#__PURE__*/_react.default.createElement(DropdownNestedContainer, {
            key: `nested-${nestedParentIndex}`,
            "data-nested-for": nestedParentIndex
          }, /*#__PURE__*/_react.default.createElement(DropdownNestedItems, null, nestedItems.map((nestedItem, nestedIndex) => /*#__PURE__*/_react.default.createElement(DropdownNestedLink, {
            key: nestedIndex
          }, /*#__PURE__*/_react.default.createElement(_desktopNavLink.default, (0, _extends2.default)({
            tabIndex: 0
          }, nestedItem))))));
        }
        return null;
      }))));
    }
    const {
      _name: itemName,
      active,
      anchor
    } = menuItem;
    return /*#__PURE__*/_react.default.createElement(_desktopMenuItem.default, {
      key: itemIndex,
      _name: itemName,
      order: itemIndex,
      "data-active": active,
      partial: partial,
      itemText: /*#__PURE__*/_react.default.createElement(_desktopNavLink.default, (0, _extends2.default)({}, menuItem, {
        anchorId: anchor,
        "data-partial": partial,
        tabIndex: 0,
        scrollToAnchor: scrollToAnchor,
        partial: partial
      }))
    });
  }), hasOverflow && moreItems?.length > 0 && /*#__PURE__*/_react.default.createElement(MoreButtonDesktopMenuItem, {
    key: "more-button",
    _name: "more-dropdown",
    order: visibleItemsCount,
    itemText: "More",
    "data-cy": "more-nav-item",
    "data-more-active": isMoreButtonActive(),
    tabIndex: 0,
    ref: moreDropdownRef
  }, /*#__PURE__*/_react.default.createElement(DropdownListContainer, null, /*#__PURE__*/_react.default.createElement(DropdownMainContainer, {
    onMouseEnter: () => {
      if (hoveredMoreItemIndex === null && clickedMoreItemIndex === null) {
        setHoveredMoreItemIndex(-1);
      }
    },
    onMouseLeave: () => {
      if (hoveredMoreItemIndex === -1 && clickedMoreItemIndex === null) {
        setHoveredMoreItemIndex(null);
      }
    }
  }, /*#__PURE__*/_react.default.createElement(DropdownItemsContainer, {
    "data-cy": "more-dropdown-list",
    "data-partial": partial
  }, moreItems.map((item, itemIndex) => {
    const {
      items
    } = item || {};
    const processedItemList = extractItemList(items);
    if (hasDropdownContent(items, processedItemList)) {
      const {
        title
      } = item;
      return /*#__PURE__*/_react.default.createElement(DropdownLink, {
        "data-cy": "more-nested-item",
        key: itemIndex
      }, /*#__PURE__*/_react.default.createElement(MoreNestedItemLink, {
        "data-active": item.active || clickedMoreItemIndex === itemIndex,
        tabIndex: 0,
        onMouseEnter: () => showSubmenu(itemIndex),
        onMouseLeave: hideSubmenu,
        "data-cy": "more-nested-item-link",
        onClick: e => {
          e.preventDefault();
          handleParentItemClick(itemIndex);
        }
      }, title, /*#__PURE__*/_react.default.createElement(MoreNestedChevron, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        name: "chevron-right"
      }))));
    }
    return /*#__PURE__*/_react.default.createElement(DropdownLink, {
      key: itemIndex
    }, /*#__PURE__*/_react.default.createElement(_desktopNavLink.default, (0, _extends2.default)({}, item, {
      anchorId: item.anchor,
      tabIndex: 0,
      scrollToAnchor: scrollToAnchor
    })));
  })), moreItems.map((item, itemIndex) => {
    const {
      items
    } = item || {};
    const processedItemList = extractItemList(items);
    if (hasDropdownContent(items, processedItemList)) {
      return /*#__PURE__*/_react.default.createElement(MoreSubDropdown, {
        key: `more-sub-${itemIndex}`,
        isVisible: isSubmenuVisible(itemIndex),
        "data-cy": "nested-item-submenu",
        onMouseEnter: () => {
          cancelHideSubmenu();
          showSubmenu(itemIndex);
        },
        onMouseLeave: hideSubmenu
      }, /*#__PURE__*/_react.default.createElement(MoreSubDropdownItems, null, processedItemList?.map((nestedItem, nestedIndex) => /*#__PURE__*/_react.default.createElement(DropdownNestedLink, {
        key: nestedIndex
      }, /*#__PURE__*/_react.default.createElement(_desktopNavLink.default, (0, _extends2.default)({}, nestedItem, {
        tabIndex: 0,
        scrollToAnchor: scrollToAnchor
      }))))));
    }
    return null;
  }))))));
}
NavbarCenterSection.propTypes = {
  liveList: _propTypes.default.array.isRequired,
  scrollToAnchor: _propTypes.default.func.isRequired,
  partial: _propTypes.default.string,
  listMenuRef: _propTypes.default.object.isRequired,
  isDesktop: _propTypes.default.bool,
  hasOverflow: _propTypes.default.bool,
  visibleItemsCount: _propTypes.default.number,
  moreItems: _propTypes.default.array
};